var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', [_c('playable'), _vm._v(" "), _c('points'), _vm._v(" "), _c('playsmart')], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };